<!-- <div style="padding-left: 5em;">
    <div style="justify-content: center; display: flex; border-bottom: 1px solid grey;">
        <label style="margin: 0; font-size: 11px;">COLUMN DISPLAY</label>
    </div>
    <div style="padding-left: 1vw; padding-top: 1vh; display: flex; flex-direction: row;">
        <span class="p-input-icon-left">
            <i *ngIf="columnSearchValue != null" class="pi pi-times" (click)="clearSearch()" style="font-size: 12px; vertical-align:middle;"></i>
            <input id="search" type="text" pInputText placeholder="Find Columns" [(ngModel)]="columnSearchValue" (ngModelChange)="searchTextChanged()"/>
            <button pButton pRipple class="p-button-secondary" [icon]="icon" (click)="this.scrollToColumn(this.columnSearchValue)" style="font-size: 1em;"></button>
        </span>
    </div>
</div> -->

<div style="padding-left: 1vw; display: flex; flex-direction: row;">
    <span class="p-input-icon-left">
        <i *ngIf="columnSearchValue != null" class="pi pi-times" (click)="clearSearch()" style="font-size: 1em; vertical-align:middle;"></i>
        <input id="search" type="text" pInputText placeholder="Find a column..." [(ngModel)]="columnSearchValue" (ngModelChange)="searchTextChanged()"/>
        <button pButton pRipple class="p-button-secondary" [icon]="icon" (click)="this.scrollToColumn(this.columnSearchValue)" style="font-size: 1em;"></button>
    </span>
</div>


